import { render, staticRenderFns } from "./TabelaPesquisas.vue?vue&type=template&id=016cf0e8&scoped=true&"
import script from "./TabelaPesquisas.vue?vue&type=script&lang=js&"
export * from "./TabelaPesquisas.vue?vue&type=script&lang=js&"
import style0 from "./TabelaPesquisas.vue?vue&type=style&index=0&id=016cf0e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016cf0e8",
  null
  
)

export default component.exports